import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { UserAvatar } from "@components/avatar/UserAvatar";
import { memo } from "react";
import { HStack } from "@design-system/HStack/HStack";
import { NestedTaskRow } from "../../types";

export const CompletedByCell = memo(
    ({
        row,
    }: CellContext<
        ViewTableFeatures,
        NestedTaskRow,
        NestedTaskRow["lastDoneBy"]
    >) => {
        const task = row.original;

        if (task.isGroup || task.isNewPlaceholder) {
            return null;
        }

        if (!task.lastDoneBy) {
            return (
                <ViewTableCell>
                    <div>-</div>
                </ViewTableCell>
            );
        }

        return (
            <ViewTableCell>
                <HStack gap={8} align="center">
                    <UserAvatar user={task.lastDoneBy} size="sm" aria-hidden />
                    {task.lastDoneBy.name}
                </HStack>
            </ViewTableCell>
        );
    },
);
